import { keepPreviousData } from '@sopranodesign/pulse-hooks';

const query = {
  placeholderData: keepPreviousData,
  staleTime: Infinity
};

export default query;
